import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	SCHOLARSHIP_TYPE_FEATURE_KEY,
	ScholarshipTypeState,
	ScholarshipTypePartialState,
	scholarshipTypeAdapter
} from './scholarshiptype.reducer';

// Lookup the 'ScholarshipType' feature state managed by NgRx
export const getScholarshipTypeState = createFeatureSelector<ScholarshipTypePartialState, ScholarshipTypeState>(
	SCHOLARSHIP_TYPE_FEATURE_KEY
);

const { selectAll, selectEntities } = scholarshipTypeAdapter.getSelectors();

export const getScholarshipTypeLoaded = createSelector(
	getScholarshipTypeState,
	(state: ScholarshipTypeState) => state.loaded
);

export const getScholarshipTypeError = createSelector(
	getScholarshipTypeState,
	(state: ScholarshipTypeState) => state.error
);

export const loadingScholarshipType = createSelector(
	getScholarshipTypeState,
	(state: ScholarshipTypeState) => state.loaded
);

export const getAllScholarshipType = createSelector(getScholarshipTypeState, (state: ScholarshipTypeState) =>
	selectAll(state)
);

export const getScholarshipTypeEntities = createSelector(getScholarshipTypeState, (state: ScholarshipTypeState) =>
	selectEntities(state)
);

export const getSelectedId = createSelector(
	getScholarshipTypeState,
	(state: ScholarshipTypeState) => state.selectedScholarshipTypeId
);

export const getSelected = createSelector(
	getScholarshipTypeEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
